module.exports = __webpack_public_path__ + "static/media/Does-A1Recycling-buys-car-with-mechanical-problems.0b470ef0.jpg";